import { requestIdHeader } from '@thinkalpha/common/contracts/x-headers.js';
import { AxiosError } from 'axios';
import { APIError } from 'src/api/error';
import type { ResponseData } from 'src/hooks/useSnackbar';
import { TradingSocketError } from 'src/services/TradingSocketService';
import type { SnackbarOptions } from 'src/store/actions/ui';

interface SnackbarErrorData {
    options: SnackbarOptions;
    responseData: ResponseData;
    /** User-facing error message sent by the server, when the response body carries one. */
    errorMessage?: string;
}

export function snackbarErrorData(error: Error): SnackbarErrorData {
    const responseData: ResponseData = {};
    let errorMessage: string | undefined;

    if (error instanceof AxiosError) {
        responseData.requestId = error.response?.data?.requestId ?? error.config?.headers[requestIdHeader];
        responseData.debugMessage = error.response?.data?.debugMessage;
        const data = error.response?.data;
        if (typeof data?.message === 'string') {
            errorMessage = data.message;
        } else if (typeof data?.error === 'string') {
            errorMessage = data.error;
        }
    } else if (error instanceof APIError) {
        responseData.requestId = error.requestId;
    } else if (error instanceof TradingSocketError) {
        responseData.requestId = error.requestId;
    }

    return { options: { variant: 'error' }, responseData, errorMessage };
}
